import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Box,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetBlogsQuery } from "../redux/Apis/Blog";

const Blogs = () => {
  const navigate = useNavigate();
  const {
    data: response,
    isLoading,
    isError,
    refetch,
  } = useGetBlogsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '')
      .split('-')
      .slice(0, 4)
      .join('-');
};

  const handleNavigate = (id, title) => {
    const slug = createSlug(title);
    navigate(`/blogg/${slug}`);
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading blogs</div>;

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 6 }}>
        <Typography variant="h6" sx={{ mb: 4, color: "#555" }}>
          All Posts
        </Typography>
        <Grid container spacing={2}>
          {response?.data?.map((blog) => (
            <Grid item xs={12} key={blog._id}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  height: { xs: "auto", md: 250 },
                }}
              >
                {blog.image && (
                  <CardMedia
                    component="img"
                    image={`${process.env.REACT_APP_IMAGE_BASE_URL}${blog.image}`}
                    alt={blog.title}
                    sx={{
                      width: { xs: "100%", md: 400 },
                      height: { xs: 150, sm: 350, md: 250 },
                      objectFit: "fill",
                      flexShrink: 0,
                    }}
                  />
                )}
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    flexGrow: 1,
                    width: { md: "70%" },
                    p: 3,
                    overflow: "hidden",
                  }}
                  onClick={() => handleNavigate(blog._id, blog.title)}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      cursor: "pointer",
                      fontSize: { xs: "1.1rem", md: "1.25rem" },
                    }}
                  >
                    {blog.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      cursor: "pointer",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {blog.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Blogs;
